var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show)?_c('div',{staticClass:"home-header-fullscreen"},[_c('Tooltip',{attrs:{"content":_vm.flag ? '退出全屏' : '进入全屏'}},[_c('tIcon',{attrs:{"name":"arrows-alt"},nativeOn:{"click":function($event){return _vm.fullscreen.apply(null, arguments)}}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }